<template>
  <div style="overflow-x: hidden;background-color: white;position: absolute;left: 0;right: 0;top: 0" class="bg">
    <Navigator/>
    <SliderBanner :slider="slider"/>
    <FuncShow :funInfo="funInfo" style="background: #F4F7FF; ">
    </FuncShow>
    <Footer/>
    <ContactFloat/>
  </div>
</template>

<script>
import Navigator from '../widgets/navigator'
import Footer from '../widgets/footer'
import SliderBanner from '../widgets/SliderBanner'
import FuncShow from '../widgets/func-show'
import ContactFloat from '../widgets/contact-float.vue'

export default {
  components: {
    Navigator,
    FuncShow,
    ContactFloat,
    SliderBanner,
    Footer
  },
  data() {
    return {
      slider: {
        image: require('@/assets/images/index/advert/phone.png'),
        title: '广告任务',
        desc: "吸粉神器任务大厅(广告任务、注册任务、拉新任务、购物任务、分享任务等等),全域优质广告媒体赚钱"
      },
      funInfo: {
        title: '广告任务',
        list: [
          {
            title: '任务中心',
            img: require('@/assets/images/index/advert/img2.png'),
            text: '完成任务，赚更多积分和金币，换去现金红包'
          },
          {
            title: '插屏广告',
            img: require('@/assets/images/index/advert/img3.png'),
            text: '具有强烈的视觉冲击效果'
          },
          {
            title: '开屏广告',
            img: require('@/assets/images/index/advert/img4.png'),
            text: '开屏广告,可自定义流量分组,对用户进行打标,精细化运营实现高流量价值变现.精准智能分配策略,提供真实透明全面变现服务,持续驱动变现效益提升'
          },
          {
            title: '激励视频',
            img: require('@/assets/images/index/advert/img5.png'),
            text: '激励用户观看视频，领取双倍奖励'
          }
        ]
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
